module.exports = __webpack_public_path__ + "static/media/cMurphy.9b020459.jpeg";